import {
  trackPlayerBufferComplete,
  trackPlayerBufferStart,
  trackPlayerClosed,
  trackPlayerPause,
  trackPlayerPlay,
  trackPlayerPresented,
  trackPlayerSeekComplete,
  trackPlayerSeekStart,
  trackPlayerComplete,
  trackPlayerSessionStart,
  trackPlayerError,
} from '../tracking.ts';
import type { PlayerTrackData } from '../tracking.ts';

function analyticsPlugin(
  this: any,
  {
    trackData,
  }: {
    trackData: PlayerTrackData;
  }
) {
  this.on('loadedmetadata', () =>
    trackPlayerSessionStart(trackData, this.currentTime())
  );
  this.on('ended', () => trackPlayerComplete(trackData, this.currentTime()));
  this.on('canplaythrough', () =>
    trackPlayerBufferComplete(trackData, this.currentTime())
  );
  this.on('waiting', () =>
    trackPlayerBufferStart(trackData, this.currentTime())
  );
  this.on('seeking', () => trackPlayerSeekStart(trackData, this.currentTime()));
  this.on('seeked', () =>
    trackPlayerSeekComplete(trackData, this.currentTime())
  );
  this.on('play', () => trackPlayerPlay(trackData, this.currentTime()));
  this.on('pause', () => trackPlayerPause(trackData, this.currentTime()));
  this.on('error', () => {
    const err = this.error();

    trackPlayerError(
      trackData,
      this.currentTime(),
      err
        ? {
            error: String(err.code ?? 'unknown'),
            message: err.message,
          }
        : undefined
    );
  });
  this.on('dispose', () => trackPlayerClosed(trackData, this.currentTime())); // instead of `destroy`?
  this.on('loadeddata', () =>
    trackPlayerPresented(trackData, this.currentTime())
  );
}

export default analyticsPlugin;
